import { motion } from "framer-motion";
import { BRAND } from "@/lib/brand";
import { useMobilI18n } from "@/lib/mobilI18n";

export default function MobilGallery() {
  const { m } = useMobilI18n();
  return (
    <section id="galeria-externs" data-testid="mobil-gallery" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#F2EDE5] aura-grain">
      <div className="relative max-w-7xl mx-auto">
        <p className="uppercase tracking-[0.28em] text-xs text-[#3e664c] mb-4 font-medium">{m.gallery.eyebrow}</p>
        <h2 className="font-display text-4xl md:text-5xl tracking-[-0.02em] leading-[1.05] mb-12">{m.gallery.title}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {BRAND.mobilPhotos.gallery.map((url, i) => (
            <motion.div
              key={url}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              data-testid={`mobil-gallery-photo-${i}`}
              className="group overflow-hidden rounded-2xl aspect-[3/4]"
            >
              <img src={url} alt={`${m.name} ${i + 1}`} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
